import { render } from "./SettingsContainer.vue?vue&type=template&id=b4737896&scoped=true&ts=true"
import script from "./SettingsContainer.vue?vue&type=script&lang=ts"
export * from "./SettingsContainer.vue?vue&type=script&lang=ts"

import "./SettingsContainer.vue?vue&type=style&index=0&id=b4737896&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4737896"]])

export default __exports__